module.exports = __webpack_public_path__ + "img/points_available.d282bad3.png";